module.exports = "/_next/static/images/d6183ab6e31ee554e13ea0825630b953-jorge_1@3x.png.webp";